// extracted by mini-css-extract-plugin
export default {"colorContainer":"ColorColumns_colorContainer__0HhYX","colorRow":"ColorColumns_colorRow__5Ee9K","colorCell":"ColorColumns_colorCell__GMVr8"};